import * as S from '#features/ScheduleRegistration/components/LectureRegistration/RowSearchMember/SearchLectureMember/SearchMemberForm/styles';
import { ChangeEvent, useState } from 'react';
import Icon from 'src/components/atoms/Icon';

export default function SearchInput({
  placeholder = '검색어를 입력하세요',
  onChange,
  ...props
}: React.InputHTMLAttributes<HTMLInputElement>) {
  const [query, setQuery] = useState<string>('');
  const [focused, setFocused] = useState<boolean>();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e);
  };

  return (
    <S.InputWrapper focused={focused}>
      <S.Input
        type="search"
        value={query}
        placeholder={placeholder}
        onChange={e => {
          setQuery(e.target.value);
          handleChange(e);
        }}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        {...props}
      />
      <S.Button>
        <Icon name="IconSearch" />
      </S.Button>
    </S.InputWrapper>
  );
}
